import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, eur, dt } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const ESITO = { ok: "text-emerald-700", differenza: "text-rose-600 font-semibold", mancante: "text-rose-600 font-semibold", "non ordinato": "text-amber-700 font-semibold" };
const qn = (n) => Number(n || 0).toLocaleString("it-IT", { maximumFractionDigits: 3 });

export const ConfrontoDialog = ({ order, onClose }) => {
  const [inv, setInv] = useState([]);
  const [res, setRes] = useState(null);
  useEffect(() => {
    if (!order) return;
    setRes(null);
    api.get(`/magazzino/ordini/${order.id}/fatture`).then((r) => setInv(r.data)).catch((e) => toast.error(errMsg(e)));
    if (order.fattura) api.post(`/magazzino/ordini/${order.id}/confronto`, { invoice_id: order.fattura.invoice_id }).then((r) => setRes(r.data)).catch(() => {});
  }, [order]);
  const pick = async (id) => {
    try { const { data } = await api.post(`/magazzino/ordini/${order.id}/confronto`, { invoice_id: id }); setRes(data); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={!!order} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[90vh] max-w-3xl overflow-y-auto" data-testid="order-invoice-dialog">
        <DialogHeader><DialogTitle>Ordine {order?.numero} · confronto con la fattura del fornitore</DialogTitle></DialogHeader>
        <Select value={res?.fattura?.invoice_id || undefined} onValueChange={pick}>
          <SelectTrigger data-testid="order-invoice-select"><SelectValue placeholder={inv.length ? "Scegli la fattura ricevuta…" : "Nessuna fattura ricevuta da questo fornitore"} /></SelectTrigger>
          <SelectContent>{inv.map((i) => <SelectItem key={i.id} value={i.id}>{i.numero} del {dt(i.data)} · {eur(i.totals?.totale)}</SelectItem>)}</SelectContent>
        </Select>
        {res && (
          <>
            <p data-testid="order-invoice-result" className={`rounded-md p-3 text-sm ${res.conforme ? "bg-emerald-50 text-emerald-800" : "bg-rose-50 text-rose-800"}`}>
              {res.conforme ? "Quantità e prezzi corrispondono all'ordine." : "Attenzione: ci sono differenze tra ordine e fattura."}
            </p>
            <div className="overflow-x-auto">
              <table className="w-full text-sm" data-testid="order-invoice-table">
                <thead><tr className="border-b text-left text-xs uppercase text-slate-600"><th className="py-2">Articolo</th><th className="text-right">Q. ordinata</th><th className="text-right">Q. fatturata</th><th className="text-right">Prezzo ordine</th><th className="text-right">Prezzo fattura</th><th className="pl-3">Esito</th></tr></thead>
                <tbody>
                  {res.righe.map((r, i) => (
                    <tr key={i} className="border-b border-slate-100" data-testid={`order-invoice-row-${i}`}>
                      <td className="py-2"><span className="font-mono text-xs">{r.codice}</span> {r.descrizione}</td>
                      <td className="text-right font-mono">{qn(r.q_ordinata)}</td><td className="text-right font-mono">{qn(r.q_fatturata)}</td>
                      <td className="text-right font-mono">{eur(r.prezzo_ordine)}</td><td className="text-right font-mono">{eur(r.prezzo_fattura)}</td>
                      <td className={`pl-3 ${ESITO[r.esito]}`}>{r.esito}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
